<div class="error-page">
  <div class="error-message">
    <div class="row space-top-2"><h1>{{ `application.error-page.${errorTitle}` | translate }}</h1></div>
    <div class="row space-top-2">
      <span class="error-message" [innerHTML]="`application.error-page.${errorMessage}` | translate "></span>
    </div>
    @if (reconnectionButton){
      <div class="error-button">
        <ml-loading-button class="loading-button"
          [label]="'application.error-page.button' | translate"
          [priority]="'primary'"
          [size]="'medium'"
          (event)="retryLogin()"/>
      </div>
    }
  </div>

  <div class="row center">
    <img src="../../../../assets/img/error.png" alt="error-img">
  </div>
</div>
